import { Button } from '../../../ui';

const packages = [
  {
    badge: 'CTV ստարտ',
    badgeClass: 'bg-[#FCF8D2] text-[#000000]',
    price: '1.200.000 AMD/m',
    priceClass: 'text-[#FCF8D2]',
    impressions: '700.000 impression',
    features: ['Գովազդ Youtube TV-ում', 'Գովազդ կինոկայքերում', 'Գովազդների ստեղծում և օրական օպտիմիզացիաներ', 'Ամսական հաշվետվություն'],
    highlight: false,
  },
  {
    badge: 'CTV հիմնական',
    badgeClass: 'bg-[#D5DD23] text-[#000000]',
    price: '2.500.000 AMD/m',
    priceClass: 'text-[#D5DD23]',
    impressions: '1.800.000 impression',
    features: [
      'Գովազդ Youtube TV-ում',
      'Գովազդ կինոկայքերում',
      'Ալիքներ ընտրելու հնարավորություն',
      'Գովազդների ստեղծման և օրական օպտիմիզացիաներ',
      'Շաբաթական/ Ամսական հաշվետվություն',
    ],
    highlight: true,
  },
  {
    badge: 'CTV ինտենսիվ',
    badgeClass: 'bg-[#FAC8A5] text-[#000000]',
    price: '3.200.000 AMD/m',
    priceClass: 'text-[#FAC8A5]',
    impressions: '2.400.000 impression',
    features: [
      'Գովազդ Youtube TV-ում',
      'Գովազդ կինոկայքերում',
      'Գովազդ Smart TV հավելվածներում',
      'Ալիքներ ընտրելու հնարավորություն',
      'Գովազդների ստեղծման և օրական օպտիմիզացիաներ',
      'Շաբաթական/ Ամսական հաշվետվություն',
    ],
    highlight: false,
  },
];

const Packages = () => {
  const handleScrollToOffer = () => {
    const section = document.getElementById('offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-[#3d3d3d]">
      <div className="container py-[48px] md:pt-[64px] md:py-[80px]">
        <h2 className="text-center font-[500] text-[28px] md:text-[36px] text-white mb-[32px] md:mb-[60px]">Փաթեթներ</h2>
        <div className="hide_scrollbar flex md:grid md:grid-cols-3 gap-[16px] md:gap-[32px] overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none py-[16px] -my-[16px] px-[8px] md:py-0 md:px-0 md:my-0">
          {packages.map((pkg, i) => (
            <div
              key={i}
              className={`shrink-0 w-[90%] sm:w-[320px] md:w-auto snap-start flex flex-col rounded-[16px] border p-[24px] transition-transform duration-300 hover:scale-[1.04] ${
                pkg.highlight ? 'bg-[#242820] border-white/20 md:shadow-2xl md:scale-[1.1] md:hover:scale-[1.14] md:z-10' : 'border-white/40'
              }`}
            >
              <span
                style={{ fontFamily: "'Montserrat', sans-serif" }}
                className={`inline-block self-start rounded-full px-[12px] py-[4px] text-[16px] font-[600] mb-[24px] ${pkg.badgeClass}`}
              >
                {pkg.badge}
              </span>
              <div className="border-t border-white/15 mb-[8px]" />
              <p className={`text-center text-[28px] font-[700] mb-[8px] ${pkg.priceClass}`}>{pkg.price}</p>
              <p className="text-center text-white/50 text-[14px] mb-[8px]">{pkg.impressions}</p>
              <div className="border-t border-white/15 mb-[24px]" />
              <ul className="flex flex-col gap-[24px] mb-[32px] flex-1">
                {pkg.features.map((feature, j) => (
                  <li key={j} className="flex items-start gap-[8px] text-white/80 text-[16px] font-[200] leading-[22px]">
                    <span className="text-[#9ebf91] mt-[3px]">
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                      </svg>
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>
              <Button variant="greenOffer" className="w-full" onClick={handleScrollToOffer}>
                Ստանալ Առաջարկ
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Packages;
